import React, { Component, Fragment} from 'react';
import { connect } from 'react-redux';

import BootstrapTable from 'react-bootstrap-table-next';

import 'sass/historyxxl.scss';

import Footer from '../../components/Footer';
import HeaderXXL from '../../components/XXL/HeaderXXL';

import {getMemberPaymentHistory} from 'reducers/memberPaymentHistory';

import {t, dt} from 'l10n';
import {formatHistoryDate} from 'utils/payment';

class MemberPaymentHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    componentDidMount() {
        this.props.getMemberPaymentHistory();
    }

    formatPeriod = (cell, row) => {
        return `${cell} days`
    };

    formatDate = (cell, row) => {
        return formatHistoryDate(cell)
    };

    headerFormatter = (order, column) => {
        if (!order) return (
            <div className="header-sortable">
                <p>{dt('xxl', 'Purchase date')}</p>
                <span className="icon"></span>
            </div>
        );
        else if (order === 'asc') return (
            <div className="header-sortable header-sort-asc">
                <p>{dt('xxl', 'Purchase date')}</p>
                <span className="icon"></span>
            </div>
        );
        else if (order === 'desc') return (
            <div className="header-sortable">
                <p>{dt('xxl', 'Purchase date')}</p>
                <span className="icon"></span>
            </div>
        );
        return null;
    };

    render() {
        let {paymentHistory, currentUser} = this.props;

        const columns = [
            {
                text: '',
                sort: true,
                dataField: 'date',
                headerClasses: 'date',
                formatter: this.formatDate,
                sortCaret:  this.headerFormatter,
            },
            {
                dataField: 'ticket',
                text: dt('xxl', 'Ticket number')
            },
            {
                dataField: 'duration',
                formatter: this.formatPeriod,
                text: dt('xxl', 'Period of XXL'),
            }
        ];

        return (
            <div id="wrapper">
                <HeaderXXL currentUser={currentUser} showButton showExpiration showHistoryLink={false}>
                    {dt('xxl', 'Payment history')}
                </HeaderXXL>

                <aside className="table-history-xxl">
                    <div className="content">
                        <BootstrapTable
                            keyField='id'
                            data={paymentHistory}
                            columns={ columns }
                        />
                        {!paymentHistory.length && <p className="no-items">{dt('xxl', 'You have no payments yet.')}</p>}
                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        paymentHistory: state.memberPaymentHistory
    }),({
        getMemberPaymentHistory: getMemberPaymentHistory
    })
)(MemberPaymentHistory)


// WEBPACK FOOTER //
// ./src/containers/member/MemberPaymentHistory.js